import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { LigneRevoir } from '../../../../lib/reprise.js';
import styles from './Plan.module.css';
import { ReferenceOrigine } from './ReferenceOrigine.js';

/**
 * Le delta d'un rapport (`api.md` § 12.18) : les lignes « signalées », connues
 * par leur référence d'origine et changées depuis leur reprise. Ce ne sont pas
 * des refus : rien n'a été écrasé, la liste dit seulement ce qu'il faut revoir
 * à la main. Elle se détache donc des lignes refusées, par sa place, son ton
 * et sa phrase.
 */
export function RevoirBloc({ lignes }: { lignes: readonly LigneRevoir[] }): JSX.Element | null {
  const { t } = useTranslation('console');
  if (lignes.length === 0) return null;
  return (
    <section className={styles.revoir} aria-labelledby="rapport-revoir">
      <h4 id="rapport-revoir">
        {t('plan.delta.titre')} ({lignes.length})
      </h4>
      <p>
        <strong>{t('plan.delta.rienEcrase')}</strong> {t('plan.delta.texte')}
      </p>
      <ul className={styles.revoirListe} tabIndex={0}>
        {lignes.map((entree) => (
          <li key={`${String(entree.ligne)}-${entree.refOrigine}`} className={styles.revoirLigne}>
            <span>{t('plan.delta.ligne', { ligne: entree.ligne, libelle: entree.libelle })}</span>
            <ReferenceOrigine valeur={entree.refOrigine} />
          </li>
        ))}
      </ul>
    </section>
  );
}
